
export enum TipoFrequenciaMensalEnum {
  DiaMes = 'DiaMes',
  DiaSemana = 'DiaSemana',
}
